(function () {

    "use strict";

    function manualController(basicEditService, manualesService, $q, getList) {


        var vm = basicEditService.instantiate(this);
        vm.service = manualesService;
        vm.stateList = "manuales";
       // vm.list = getList.getList.queryPaged({ id: 1 });
        vm.loadEntity().then(function () {
            vm.configHead(breadcrumbItems());
            vm.loadTask(vm);
        });

        vm.customSave = function () {
            var defered = $q.defer();
            var promise = defered.promise;
            vm.save().then(
                function () {
                    vm.configHead(breadcrumbItems());
                    defered.resolve();
                },
                function () {
                    defered.reject();
                });
            return promise;
        };

        vm.canFullScreenByExtension = function (event) {
            vm.FullscreenByExtension = event.canFullScreen;
        };
    
        function breadcrumbItems() {
            return [{
                text: "Inicio",
                action: vm.goHome
            }, {
                text: "Manuales",
                action: vm.goList
            },
            {
                text: vm.entity.application,
                action: null
            }
            ];
        }

    }

    manualController.$inject = ["sphforms.basicEditService", "sphforms.manualesService", "$q", "solpheo.getList"];

    angular.module("sphforms.formacion")
        .component("sphformsManual", {
            controller: manualController,
            bindings: {
                idEntity: "<"
            },
            templateUrl: "modules/formacion/components/manual/manual.template.html"
        });

}());
